import * as React from "react"
import { useState } from "react"

import {
  Typography,
  Grid,
  TextField,
  Link,
  Checkbox,
  Stack,
  MenuItem,
} from "@mui/material"
import * as Yup from "yup"
import { Field, FormikProvider, useFormik } from "formik"
import axios from "axios"
import { API_URL } from "../utils/config"
import * as allImages from "../utils/images"

const Enquiry = () => {
  const style = {
    formWrapper: {
      backgroundColor: "#fff",
      padding: "25px",
      borderRadius: "10px",
    },
    error: {
      color: "#FF4128",
      display: "flex",
    },
    customTextarea: {
      outline: 0,
      padding: "26px 0px 5px",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      width: "100%",
      lineHeight: "8px",
      fontSize: "14px",
    },
    formCheckBox: {
      cursor: "pointer",
      padding: "0px",
      marginRight: "10px",
      "&:hover": {
        backgroundColor: "unset",
      },
      svg: {
        fontSize: "16px",
      },
    },
  }

  const [infoMessage, setInfoMessage] = useState({})
  const [selectedValue, setSelectedValue] = useState("")
  const [isModalTrue, setModalTrue] = useState(false)
  const [isModalFalse, setModalFalse] = useState(false)

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

  const emailDomainRegExp = /\.(com|org|io|in)$/i

  const ProjectSchema = Yup.object().shape({
    FirstName: Yup.string()
      .required("*Required")
      .matches(/^[a-zA-Z]+( [a-zA-Z]+)*$/, "Name should only contain alphabets and single spaces between words"),
    LastName: Yup.string()
      .notRequired()
      .matches(/^[a-zA-Z]+$/, "Last Name should only contain alphabets"),
    CompanyName: Yup.string().notRequired(),
    JobTitle: Yup.string().notRequired(),
    MobileNumber: Yup.string().notRequired().matches(/^[0-9+]+$/, "Only numbers and + are allowed")
        .min(10, "Must be at least 10 digits")
        .max(15, "Cannot exceed 15 digits"),
    Email: Yup.string()
      .email("Enter valid Email")
      .required("*Required")
      .test(
        "No gmail, yahoo, hotmail, proton and rediffmail",
        "Please enter a valid work email",
        value => {
          if (!value) return false
          const invalidDomains = ["gmail", "yahoo", "rediffmail", "hotmail", "proton"]
          return (
            !invalidDomains.includes(value?.split("@")[1]?.split(".")[0]) 
            // && emailDomainRegExp.test(value?.split("@")[1])
          )
        }
      ),
    Assist: Yup.string().required("*Required"),
    ConnectionPreference:
      selectedValue === "Others"
        ? Yup.string()
            .min(15, "Description must be at least 15 characters")
            .max(1500, "Must be at most 1500 characters")
            .required("*Required")
        : Yup.string().notRequired(),
    Consent: Yup.boolean().oneOf([true], "Kindly select the Privacy Policy"),
  })

  interface IProps {
    FirstName: string
    LastName: string
    JobTitle: string
    CompanyName: string
    Email: string
    MobileNumber: string
    Assist: string
    ConnectionPreference: string
    Consent: boolean
  }

  const initialValues: IProps = {
    FirstName: "",
    LastName: "",
    JobTitle: "",
    CompanyName: "",
    Email: "",
    MobileNumber: "",
    Assist: "",
    ConnectionPreference: "",
    Consent: false,
    // document: "",
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: ProjectSchema,
    onSubmit: () => {
      handlLetsTalk(formik.values)
      setSelectedValue("")
    },
  })

  const handlLetsTalk = (data: any) => {
    data.Consent = false
    let newData = { ...data }
    delete newData.Consent
    const formData = new FormData()
    for (const key in newData) {
      formData.append(key, newData[key])
    }
    axios
      .post(`${API_URL}/contact`, formData)
      .then(res => {
        setInfoMessage({ message: res.data.message, status: res.status })
        setModalTrue(true)
        formik.resetForm()
      })
      .catch(error => {
        setInfoMessage({ message: error.message, status: error.status })
        setModalFalse(true)
        formik.resetForm()
        console.log(error)
      })
  }

  return (
    <>
      <FormikProvider value={formik}>
        <form 
          action="https://forms.hsforms.com/submissions/v3/integration/submit/46024254/0fb109e8-1786-41f9-86e8-5c7d2c0a660c" 
          method="POST"
          onSubmit={formik.handleSubmit}
        >
          <div style={style.formWrapper}>
            <Grid
              container
              direction="row"
              rowSpacing={1.5}
              columnSpacing={{ xs: 1, sm: 2, md: 4.5 }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <Field name="FirstName">
                  {({ field, meta }: any) => (
                    <>
                      <TextField
                        name="FirstName"
                        variant="standard"
                        label="Full Name*"
                        fullWidth
                        {...field}
                        value={field.value}
                        className="inputField"
                      />
                      {meta.touched && meta.error && (
                        <Typography sx={style.error} variant="caption">
                          {meta.error}
                        </Typography>
                      )}
                    </>
                  )}
                </Field>
              </Grid>
              {/* <Grid item xs={12} sm={6} md={6}>
                <Field name="LastName">
                  {({ field, meta }: any) => (
                    <>
                      {" "}
                      <TextField
                        name="LastName"
                        variant="standard"
                        label="Last Name*"
                        fullWidth
                        {...field}
                        value={field.value}
                        className="inputField"
                      />
                      {meta.touched && meta.error && (
                        <Typography sx={style.error} variant="caption">
                          {meta.error}
                        </Typography>
                      )}
                    </>
                  )}
                </Field>
              </Grid> */}
              {/* <Grid item xs={12} sm={6} md={6}>
                <Field name="JobTitle">
                  {({ field, meta }: any) => (
                    <>
                      <TextField
                        name="JobTitle"
                        id="JobTitle"
                        variant="standard"
                        label="Job Title"
                        fullWidth
                        {...field}
                        value={field.value}
                        className="inputField"
                      />
                      {meta.touched && meta.error && (
                        <Typography sx={style.error} variant="caption">
                          {meta.error}
                        </Typography>
                      )}
                    </>
                  )}
                </Field>
              </Grid> */}
              <Grid item xs={12} sm={6} md={6}>
                <Field name="Email">
                  {({ field, meta }: any) => (
                    <>
                      <TextField
                        type="email"
                        name="Email"
                        id="Email"
                        variant="standard"
                        label="Work Email*"
                        fullWidth
                        {...field}
                        value={field.value}
                        className="inputField"
                      />
                      {meta.touched && meta.error && (
                        <Typography sx={style.error} variant="caption">
                          {meta.error}
                        </Typography>
                      )}
                    </>
                  )}
                </Field>
              </Grid>
              {/* <Grid item xs={12} sm={6} md={6}>
                <Field name="MobileNumber">
                  {({ field, meta }: any) => (
                    <>
                      {" "}
                      <TextField
                        name="MobileNumber"
                        id="MobileNumber"
                        variant="standard"
                        label="Phone Number*"
                        fullWidth
                        {...field}
                        value={field.value}
                        inputProps={{
                          pattern: "[0-9+-]+",
                          title:
                            "Phone number should only contain numbers, + and -.",
                        }}
                        onChange={e => {
                          const validChars = /^[0-9+]+$/
                          if (
                            e.target.value === "" ||
                            validChars.test(e.target.value)
                          ) {
                            field.onChange(e)
                          }
                        }}
                        className="inputField"
                      />
                      {meta.touched && meta.error && (
                        <Typography sx={style.error} variant="caption">
                          {meta.error}
                        </Typography>
                      )}
                    </>
                  )}
                </Field>
              </Grid> */}
              {/* <Grid item xs={12} sm={6} md={6}>
                <Field name="CompanyName">
                  {({ field, meta }: any) => (
                    <>
                      <TextField
                        name="CompanyName"
                        id="CompanyName"
                        variant="standard"
                        label="Company Name*"
                        fullWidth
                        {...field}
                        value={field.value}
                        onChange={e => {
                          const validChars = /^[A-Za-z][A-Za-z\s]*$/i
                          if (
                            e.target.value === "" ||
                            validChars.test(e.target.value)
                          ) {
                            field.onChange(e)
                          }
                        }}
                        className="inputField"
                      />
                      {meta.touched && meta.error && (
                        <Typography sx={style.error} variant="caption">
                          {meta.error}
                        </Typography>
                      )}
                    </>
                  )}
                </Field>
              </Grid> */}
              {selectedValue === "Others" ? (
                <Grid item xs={12}>
                  <Field name="ConnectionPreference">
                    {({ field, meta }: any) => (
                      <>
                        <Field
                          as="textarea"
                          name="ConnectionPreference"
                          id="ConnectionPreference"
                          placeholder="How Can We Help ?*"
                          style={{
                            ...style.customTextarea,
                            ...(field.value.trim() !== "" && {
                              lineHeight: "1.2",
                            }),
                          }}
                          className="contact-dialog-textarea"
                        />
                        {meta.touched && meta.error && (
                          <Typography sx={style.error} variant="caption">
                            {meta.error}
                          </Typography>
                        )}
                      </>
                    )}
                  </Field>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Field name="Assist">
                    {({ field, meta }: any) => (
                      <>
                        <TextField
                          {...field}
                          name="Assist"
                          id="Assist"
                          variant="standard"
                          label="How can we help ?*"
                          select
                          fullWidth
                          value={selectedValue}
                          onChange={event => {
                            const value = event.target.value
                            setSelectedValue(value)
                            formik.setFieldValue("Assist", value)
                          }}
                          className="inputField"
                        >
                          <MenuItem value="Tell me about your services">
                            Tell me about your services
                          </MenuItem>
                          <MenuItem value="Let’s discuss my project">
                            Let’s discuss my project
                          </MenuItem>
                          <MenuItem value="I need a POC">I need a POC</MenuItem>
                          <MenuItem value="Just exploring">
                            Just exploring
                          </MenuItem>
                          <MenuItem value="Others">Others</MenuItem>
                        </TextField>
                        {meta.touched && meta.error && (
                          <Typography sx={style.error} variant="caption">
                            {meta.error}
                          </Typography>
                        )}
                      </>
                    )}
                  </Field>
                </Grid>
              )}
              <Grid item xs={12}>
                <Field name="Consent">
                  {({ field, meta }: any) => (
                    <>
                      <Stack
                        flexDirection="row"
                        sx={{ fontSize: 12, lineHeight: "20px" }}
                      >
                        <Checkbox
                          {...field}
                          checked={field.value}
                          sx={style.formCheckBox}
                        />
                        <span>
                          I consent to Invimatic using my personal information to fulfill this request, in line with its{" "}
                          <Link
                            href="/privacy-policy"
                            target="_blank"
                            style={{ cursor: "pointer" }}
                          >
                            Privacy Policy
                          </Link>
                        </span>
                      </Stack>
                      {meta.touched && meta.error && (
                        <Typography sx={style.error} variant="caption">
                          {meta.error}
                        </Typography>
                      )}
                    </>
                  )}
                </Field>
              </Grid>
              <Grid item xs={12}>
                <div style={{ marginTop: "5px" }}>
                  <button
                    className="commonBtn"
                    type="submit"
                    style={{ margin: "auto", alignItems: "center", padding: "6px 17px" }}
                  >
                    Submit
                    <img
                      src={allImages.whiteArrow}
                      className="arrow"
                      alt="White arrow"
                    />
                  </button>
                </div>
              </Grid>
            </Grid>
            {isModalFalse ? (
              <Typography
                variant="h4"
                fontSize={14}
                color="#dc4c5a"
                fontWeight={700}
                padding="20px 0px 10px 0px"
              >
                Unable to Submit. There has been an error submitting the form.
                Please try again.
              </Typography>
            ) : (
              ""
            )}
            {isModalTrue ? (
              <Typography
                variant="h4"
                fontSize={14}
                color="#218524"
                fontWeight={700}
                padding="20px 0px 10px 0px"
              >
                Your request has been submitted! Expect to hear from us shortly!
              </Typography>
            ) : (
              ""
            )}
          </div>
        </form>
      </FormikProvider>
    </>
  )
}

export default Enquiry
